import React from "react";
import MenuGrid from "../MenuGrid";

const SECTIONS = [
  {
    title: "Personal",
    items: [
      { label: "Empleados", icon: "fas fa-address-card", href: "/Empleados", key: "empleados.empleados.ver" },
      { label: "Puestos",   icon: "fas fa-address-book", href: "/Puestos",   key: "empleados.puestos.ver"   },
    ],
  },
];

function BotonesNominas() {
  return (
    <MenuGrid
      title="Empleados"
      subtitle="Personal y puestos de trabajo"
      icon="fas fa-id-badge"
      accent={{ color: "#6366f1", bg: "#eef2ff" }}
      modulo="empleados"
      sections={SECTIONS}
    />
  );
}

export default BotonesNominas;
